import { MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from 'dayjs';
import { useEffect } from "react";
import classes from "../CustomInputs.module.css";

const TimePickerInput = (props) => {
  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [props.value]);

  // added
  const handleTimeChange = (event) => {
    props.onChange({ [props.id]: event });
  };

  const handleChange = (event) => {
    props.onChange({ [props.id]: event });
  };

  return (
    <div className={`${classes.customTextField} ${classes.customTimeTextField}`}>
      {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileTimePicker
          label={props.label}
          value={props.value ? dayjs(props.value) : null}
          onChange={(newValue) => {

            handleTimeChange(newValue?.toDate()); // handleChange(newValue)
          }}
          minutesStep={30}
        />
        {/* <TimePicker
          label={props.label}
          value={props.value}
          onChange={(newValue) => {
            handleTimeChange(newValue); // handleChange(newValue)
          }}
          minutesStep={30}
          InputProps={{
            classes: {
              notchedOutline: classes.timeField
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              error={props.isStepSubmitted && props.hasError}
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              helperText={
                props.isStepSubmitted && props.hasError ? props.errorMessage : ""
              }
              value={props.value}
              
              FormHelperTextProps={{
                classes: {
                  error: classes.error
                },
              }}
            />
          )}
        /> */}
      </LocalizationProvider>
    </div>
  );
};

export default TimePickerInput;
